import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e052da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tutorial-guide-container" }
const _hoisted_2 = { class: "tutorial-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], { title: "튜토리얼" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Tutorial"], { class: "tutorial" })
    ])
  ]))
}